
import { DP_KPMETRIC } from "../../../constants/Constant";
import Spinner from "../../../utils/Spinner";
import BIWidgetOverview from "../Widgets/BIWidgetOverview";

const KpiMetricData = (props) => {

    return (
        <>
            {
                props.catalogData?.catalogLoading ? (
                    <div className="justify-content-md-center">
                        <Spinner
                            text="KPI Product"
                        />
                    </div>
                ) : (<BIWidgetOverview
                    catalogData={props.catalogData}
                    name="Data Products - KPI/Metrics "
                    compType={DP_KPMETRIC}
                />)}
        </>
    );
};

export default KpiMetricData;
